exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proposalCoverPageDiv .ankaCropper__selectButton {\n  display: none;\n}\n#proposalCoverPageDiv .ankaCropper__droparea div {\n  background-image: none;\n  ont-size: 25px;\n  font-weight: 400;\n}\n", ""]);

// exports
